<div class="container">
    <div class="row mb-4">
        <div class="col-4">
            <div class="flex flex-column gap-2">
                <label for="identifier" class="form-label">Generic Integration Client Id</label>
                <input
                    id="identifier" 
                    pInputText
                    [(ngModel)]="model.identifier"
                    required
                    class="form-control w-100"
                />
            </div>
        </div>
        <div class="col-4">
            <div class="flex flex-column gap-2">
                <label for="integrationClientId" class="form-label">Client Id</label>
                <input 
                    id="integrationClientId"
                    pInputText
                    [(ngModel)]="model.integrationClientId"
                    required
                    class="form-control w-100"
                />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <p-toast></p-toast>
                <p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
                <p-table
                    #dt
                    [value]="model.customFields"
                    dataKey="id"
                    [tableStyle]="{'min-width': '50rem'}"
                    [paginator]="false"
                    [rows]="10"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 25, 50]"
                    [styleClass]="'p-datatable-sm'"
                    [globalFilterFields]="['name']"
                    [scrollable]="true" 
                    scrollHeight="500px"
                >
                    <ng-template pTemplate="caption">
                        <div class="row">
                            <div class="col-md-6 text-left">
                                <h4 class="mt-2">Custom Fields</h4>
                            </div>
                            <div class="col-md-6 text-right">
                                <p-button
                                    icon="pi pi-plus"
                                    styleClass="p-button-sm"
                                    label="Add Custom Field"
                                    (click)="addCustomField()"
                                ></p-button>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Field</th>
                            <th>Value</th>
                            <th>Actions</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-customField let-rowIndex="rowIndex">
                        <tr>
                            <td>
                                <input 
                                    pInputText
                                    [(ngModel)]="customField.field"
                                    required
                                    class="form-control w-100"
                                />
                            </td>
                            <td>
                                <input 
                                    pInputText
                                    [(ngModel)]="customField.value"
                                    required
                                    class="form-control w-100"
                                />
                            </td>
                            <td>
                                <p-button
                                    [icon]="'pi pi-trash'"
                                    [styleClass]="'p-button-rounded p-button-text p-button-danger'"
                                    (click)="deleteCustomField(rowIndex)"
                                ></p-button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>